/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createMultiply } from '../../factoriesNumber.js';
export var multiplyDependencies = {
  typedDependencies,
  createMultiply
};